import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { brandInfo } from '@/mocks/brand';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 bg-primary-500 rounded-lg flex items-center justify-center">
                  <i className="ri-vip-crown-line text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50">乐鱼</span>
              </Link>
              <p className="text-sm leading-relaxed text-background-50/60">
                官方正版入口，安全可信赖。致力于为用户提供安全、稳定、流畅的在线娱乐体验。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-sm text-background-50/70"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-sm text-background-50/70"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line text-sm text-background-50/70"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">内容分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速链接</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">首页</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">关于我们</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">联系我们</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">常见问题</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系我们</h4>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-background-50/60">{brandInfo.contact.email}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-background-50/60">{brandInfo.contact.phone}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-time-line text-primary-400 mt-0.5"></i>
                  <span className="text-sm text-background-50/60">{brandInfo.contact.workingHours}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 乐鱼官网 版权所有 | 官方正版入口，安全可信赖
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/40">
              <a href="#" className="hover:text-background-50/70 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-background-50/70 transition-colors">服务条款</a>
              <a href="#" className="hover:text-background-50/70 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}